/*
 * @Author: Gao Deng gaodeng@nextmar.com
 * @Date: 2023-10-30 13:36:21
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { httpRequest, request } from '../request';

const detail = {
  productDetail: (
    id: number,
    data: {
      // 数组类型参数会通过 qs 序列化为 query 参数
      // 例如：[1, 2, 3] 会被转换为 ?correlation_ids[0]=1&correlation_ids[1]=2&correlation_ids[2]=3
      // 或者：?correlation_ids=1&correlation_ids=2&correlation_ids=3（取决于 qs 的配置）
      // 后端接收时需要是字符串数组，所以这里需要转换
      correlation_ids?: (string | number)[];
      sold_out_jump?: number;
      special_jump?: number;
    },
  ) =>
    httpRequest('GET:/api/products/show/{product_id}', {
      product_id: id.toString(),
      params: {
        ...data,
        // 确保 correlation_ids 是字符串数组
        correlation_ids: data?.correlation_ids?.map((itemId) => String(itemId)),
      },
    }),
  // 新版评论接口（分页）
  productReviewNew: (data: {
    product_id: string;
    filter?: {
      order?: string;
    };
    page?: number;
    limit?: number;
  }) =>
    httpRequest('GET:/api/products/reviews_new', {
      params: data,
    }),
  // 添加helpful 评论点赞
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  addHelpFulApi: (data: any) => request('/api/customer/add_helpful', 'post', data),
  // 移出helpful 取消评论点赞
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeHelpFulApi: (data: any) => request('/api/customer/remove_helpful', 'post', data),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  notify: (data: any) =>
    request(`/api/products/notify/${data.id}`, 'post', data, {
      successMsg: true,
      errorMsg: true,
      msgType: 'box',
    }),
  lens: (data: {
    prescription_type: string;
    product_id: string;
    od_sph: string;
    od_cyl: string;
    od_add: string;
    os_sph: string;
    os_cyl: string;
    os_add: string;
    is_prism: string;
    is_point: string;
    lens_type_group_id?: string;
    currency: string;
  }) => httpRequest('GET:/api/lens/lens_show', { params: data }),
  coatings: () => request('/api/lens/coatings_show', 'get'),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  uploadPrescription: (data: any) =>
    request('/api/customer/prescription/help_zendesk', 'post', data),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recommend: (data: any) => request('/api/products/recommend', 'get', data, { errorMsg: false }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  recommendById: (data: any) =>
    request('/api/products/recommend_id', 'get', data, { errorMsg: false }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  prescriptionRecognition: (data: any) =>
    request('/api/lens/prescription_recognition', 'get', data, { errorMsg: false }),
  lastProcessLens: (data: { product_id: string; currency: string }) =>
    httpRequest('GET:/api/lens/get_last_lens', { params: data }, { errorMsg: false }),
  prescriptionShow: (data: { product_id: string }) =>
    httpRequest('GET:/api/lens/prescription_show', { params: data }, { errorMsg: false }),
  // bff商详接口
  bffProductDetailPC: (
    id: string | number,
    data: {
      // 数组类型参数会通过 qs 序列化为 query 参数
      // 例如：[1, 2, 3] 会被转换为 ?correlation_ids[0]=1&correlation_ids[1]=2&correlation_ids[2]=3
      // 或者：?correlation_ids=1&correlation_ids=2&correlation_ids=3（取决于 qs 的配置）
      // 后端接收时需要是字符串数组，所以这里需要转换
      correlation_ids?: number[];
      sold_out_jump?: number;
      special_jump?: number;
    },
  ) =>
    httpRequest('GET:/api/bff/product_detail_pc/{product}', {
      product: String(id),
      params: {
        ...data,
        // 确保 correlation_ids 是字符串数组
        correlation_ids: data?.correlation_ids?.map((itemId) => String(itemId)),
      },
    }),
  bffProductReviews: (data: {
    images?: {
      product_id?: number;
      filter?: Record<string, string>;
      page?: number;
      limit?: number;
    };
    reviews?: {
      product_id?: number;
      page?: number;
      limit?: number;
      filter?: Record<string, string>;
    };
  }) => httpRequest('POST:/api/bff/pc_reviews', { data }),
  bffRecommend: (data: {
    id?: number;
    limit?: number;
    page?: number;
    type?: number;
    shop_sku?: string;
  }) => httpRequest('POST:/api/bff/recommend_pc', { data }),
  bffDetailPageCouponTips: (data: { product_id: number }) =>
    httpRequest('POST:/api/bff/get_product_coupon_tips', { data }),
  /** 商详 SEO 聚合（与 PC 商详参数对齐，供爬虫 SSR 使用） */
  bffGoodsDetailSeo: (
    id: string | number,
    data: {
      correlation_ids?: number[];
      sold_out_jump?: number;
      special_jump?: number;
      images?: {
        product_id?: number;
        filter?: Record<string, string>;
        page?: number;
        limit?: number;
      };
      reviews?: {
        product_id?: number;
        page?: number;
        limit?: number;
        filter?: Record<string, string>;
      };
    },
  ) =>
    httpRequest('POST:/api/bff/product_detail_seo/{product}', {
      product: String(id),
      data: {
        sold_out_jump: data.sold_out_jump,
        special_jump: data.special_jump,
        correlation_ids: data.correlation_ids?.map((itemId) => Number(itemId)),
        images: data.images,
        reviews: data.reviews,
      },
    }),
};

export default detail;
